import { type Field } from '../ui/form/types';

export const overrideFieldIds = (
  fields: Field[],
  newFieldIdsByTarget: Record<string, string>,
) => {
  return fields.map((field) => ({
    ...field,
    id: 'target' in field ? newFieldIdsByTarget[field.target] : field.id,
  }));
};
